module.exports = __webpack_public_path__ + "static/media/tullow-oil-logo-charcoal.59f6896d.svg";